export default (value) => String(value).toLowerCase();
